<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/Ld9EOY/tc-custom/9781612436227.jpg?1702597683305" alt="This image is the cover for the book Focus & Filter"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Focus & Filter
      </h1>
      <p class="bookDescription body article font2">
        <b>Free yourself from Auto Mode with indispensable tricks and techniques for professional-quality photos with your DSLR or mirrorless camera.</b><br/>  <br/> Revealing insider secrets and easy-to-learn techniques for stunning photos, this book teaches you how to take beautiful images anywhere with DSLR or mirrorless cameras. <i>Focus &amp; Filter</i>, a must-have guide by award-winning photographer Andrew Darlow, features fifty techniques, fifty Pro Assignments, and more than 250 color photographs that show you how to capture:<br/>  <br/> *Candid and formal portraits<br/> *Safari-quality animal pictures<br/> *Spectacular nighttime cityscapes<br/> *Breathtaking fireworks photos<br/> *Dramatic high-speed motion<br/> *Mouthwatering food photos<br/> *Glare-free shots through glass<br/>  <br/> Whether you’re enjoying a hobby or building a career in photography, <i>Focus &amp; Filter</i> includes all the technical advice you need to hone your skills, from choosing your equipment and setting up your studio to mastering camera settings, working in the field, and building rapport with your models. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew Darlow
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Ulysses Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b086b548